import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { AGENCY_INIT_LOADING, AGENCY_INIT_SUCCESS, AGENCY_INIT_FAIL, AGENCY_QUOTESETTINGS_INIT_LOADING, AGENCY_QUOTESETTINGS_INIT_SUCCESS, AGENCY_QUOTESETTINGS_INIT_FAIL } from '@/store/types'

export const general = {
  async agencyInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.agency
    if (apiUrl) {
      commit(AGENCY_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(AGENCY_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(AGENCY_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(AGENCY_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  },
  async quoteSettingsInit({ commit, state }) {
    const apiUrl = state.menu.quotation
    if (apiUrl) {
      commit(AGENCY_QUOTESETTINGS_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(AGENCY_QUOTESETTINGS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(AGENCY_QUOTESETTINGS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(AGENCY_QUOTESETTINGS_INIT_FAIL, ['Invalid API URL'])
    }
  }
}
